import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spin, Result, Button } from 'antd';
import { API_URL } from 'env';

const TelegramCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        setLoading(true);
        setError(null);

        // Lấy tất cả parameters từ URL
        const params = {
          user_id: searchParams.get('user_id'),
          id: searchParams.get('id'),
          first_name: searchParams.get('first_name'),
          last_name: searchParams.get('last_name'),
          username: searchParams.get('username'),
          auth_date: searchParams.get('auth_date'),
          hash: searchParams.get('hash'),
        };

        // Kiểm tra các tham số bắt buộc
        if (!params.user_id || !params.id || !params.hash) {
          throw new Error('Missing required parameters');
        }

        console.log('Telegram callback parameters:', params);

        // Gọi API backend với URL cụ thể
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([_, value]) => value !== null)
        ) as Record<string, string>;
        const queryString = new URLSearchParams(filteredParams).toString();
        const fullUrl = `${API_URL}/api/v1/telegram/callback?${queryString}`;
        
        const response = await fetch(fullUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        console.log('Backend response:', data);
        
        if (data && data.success !== false) {
          setSuccess(true);
          
          navigate('/accounts-overview');
        } else {
          throw new Error(data?.message || 'Failed to process callback');
        }

      } catch (err) {
        console.error('Telegram callback error:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <Spin size="large" />
        <p style={{ color: '#666', fontSize: '16px' }}>
          Processing Telegram authentication...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '20px'
      }}>
        <Result
          status="error"
          title="Authentication Failed"
          subTitle={error}
          extra={[
            <Button type="primary" key="retry" onClick={() => window.location.reload()}>
              Try Again
            </Button>,
            <Button key="home" onClick={() => navigate('/')}>
              Go Home
            </Button>
          ]}
        />
      </div>
    );
  }

  if (success) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '20px'
      }}>
        <Result
          status="success"
          title="Authentication Successful"
          subTitle="You have been successfully authenticated with Telegram. Redirecting to dashboard..."
          extra={[
            <Button type="primary" key="dashboard" onClick={() => navigate('/accounts-overview')}>
              Go to Accounts Overview
            </Button>
          ]}
        />
      </div>
    );
  }

  return null;
};

export default TelegramCallback;
